
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 300 300"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2008"}},[_c('g',{attrs:{"data-name":"Rectangle 3340","fill":"none","stroke-width":"10"}},[_c('rect',{attrs:{"width":"300","height":"300","rx":"150"}}),_c('rect',{attrs:{"x":"10","y":"10","width":"280","height":"280","rx":"140"}})]),_c('path',{attrs:{"data-name":"Polygon 111","d":"M191.91 134.31a20.003 20.003 0 01-.587 34.552l-60.905 34.153a20.003 20.003 0 01-29.784-17.786l1.196-70.358a20.003 20.003 0 0130.37-16.765z"}})])])
          )
        }
      }
    